import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

export interface DownloadElement {
    'downloadID': number | null,
    'type': string,
    'name': string,
    'azureID': string | null,
    'publishDate': string | null,
    'startDate': string,
    'endDate': string,
    'fileType': string,
    'version': number
}

@Injectable()
export class DownloadService {
    downloadsList: BehaviorSubject<DownloadElement[] | null> = new BehaviorSubject<DownloadElement[] | null>(null);
    loadFailed = false;

    get downloadsUpdated(): Observable<DownloadElement[] | null> {
        return this.downloadsList.asObservable();
    }

    constructor( private http: HttpClient, private oktaService: OktaService ) {}

    refresh() {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        this.http.get<any>(environment.azure.url + '/downloads', options)
            .subscribe({
                next: data => {
                    this.downloadsList.next(data);
                    this.loadFailed = false;
                },
                error: msg => {
                    this.loadFailed = true;
                    this.downloadsList.next(null);
                    console.log(msg);
                }
            });
    }

    add( file: File, download: DownloadElement ): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        let formData = new FormData();
        formData.append("File", file);
        formData.append("Type", download.type );
        formData.append("Name", download.name );
        formData.append("StartDate", download.startDate );
        formData.append("EndDate", download.endDate );
        formData.append("FileType", download.fileType );
        formData.append("Version", download.version.toString() );
        if ( download.publishDate ) {
            formData.append("PublishDate", download.publishDate );
        }
        
        return this.http.post<any>(environment.azure.url + '/admin.downloads.add', formData, options);
    }

    remove( target: DownloadElement ): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        return this.http.post<any>(environment.azure.url + '/admin.downloads.remove', 
            {
                downloadID: target.downloadID,
                type: target.type,
                name: target.name,
                azureID: target.azureID,
                publishDate: target.publishDate,
                startDate: target.startDate,
                endDate: target.endDate,
                fileType: target.fileType,
                version: target.version
            },
            options );  
    }

    update( target: DownloadElement ): Observable<any> {
        // Update target in database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.post<any>(environment.azure.url + '/admin.downloads.update',
            {
                downloadID: target.downloadID,
                type: target.type,
                name: target.name,
                azureID: target.azureID,
                publishDate: target.publishDate,
                startDate: target.startDate,
                endDate: target.endDate,
                fileType: target.fileType,
                version: target.version
            }, 
            options );
    }
}